import { useContext } from 'react';
import { FeatureFlagContext } from './FeatureFlagProvider';

export default function useFeatureFlagContext() {
  const featureFlagContext = useContext(FeatureFlagContext);
  return featureFlagContext;
}
